import React, { useState } from "react";
import axios from "axios";
import Alert from "./Alert"; // import Alert

export default function Login({ setUser })
{
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [alertMsg, setAlertMsg] = useState({ type: "", message: "" });

  const handleLogin = async () =>
  {
    try
    {
      const res = await axios.post("https://bidashboard.miplapp.in/backend/api/login", { username, password });
      localStorage.setItem("user", JSON.stringify(res.data));
      setUser(res.data);

      if (res.data.role === "admin") window.location.href = "/admin";
      else window.location.href = "/user";

    } catch (err)
    {
      setAlertMsg({ type: "error", message: err.response?.data?.error || "Login failed" });
    }
  };

  return (
    <div className="login-page">
      <div className="form-container">
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>

        {alertMsg.message && (
          <Alert
            type={alertMsg.type}
            message={alertMsg.message}
            onClose={() => setAlertMsg({ type: "", message: "" })}
          />
        )}
      </div>
    </div>
  );
}
